import { Link } from 'react-router-dom';

const GROUPS = [
  {
    title: 'Discover',
    links: [
      { label: 'Explore', to: '/' },
      { label: 'Search', to: '/search' },
      { label: 'Buy', to: '/search?offer=free' },
    ],
  },
  {
    title: 'Create & Earn',
    links: [
      { label: 'Create', to: '/create' },
      { label: 'Upload', to: '/upload' },
      { label: 'Connect tools', to: '/connect' },
      { label: 'Earn', to: '/earn' },
    ],
  },
  {
    title: 'Developers',
    links: [
      { label: 'Connect', to: '/connect' },
      { label: 'Design system', to: '/design-system' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Community', to: '/about#community' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help', to: '/about#help' },
      { label: 'Terms', to: '/about#terms' },
      { label: 'Privacy', to: '/about#privacy' },
      { label: 'Accessibility', to: '/about#accessibility' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        {GROUPS.map((group) => (
          <div key={group.title}>
            <h3>{group.title}</h3>
            <ul>
              {group.links.map((link) => (
                <li key={`${group.title}-${link.label}`}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="muted" style={{ textAlign: 'center', marginTop: '2rem', fontSize: '0.875rem' }}>
        3DSpin · Discover it. Spin it. Make it part of your world.
      </p>
    </footer>
  );
}
